var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22214",
    "data-name": "\\uADF8\\uB8F9 22214",
    transform: "translate(-1495 -1179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28424",
    "data-name": "\\uC0AC\\uAC01\\uD615 28424",
    width: 24,
    height: 24,
    transform: "translate(1495 1179)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google",
    d: "M17.884,8.739h-7.8V11.05h5.6c-.3,3.208-2.909,4.594-5.437,4.594A6.027,6.027,0,0,1,4.183,9.527,6.019,6.019,0,0,1,14.35,5.069L15.927,3.41A8.278,8.278,0,0,0,10.136,1.1,8.54,8.54,0,0,0,1.6,9.5a8.543,8.543,0,0,0,8.618,8.427c4.54,0,7.8-3.072,7.8-7.666a5.5,5.5,0,0,0-.136-1.522Z",
    transform: "translate(1497.188 1181.486)",
    fill: "#212529"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon3);
export default __webpack_public_path__ + "static/media/FooterIcon3.d063076d1435d8d8854e465a71b8058f.svg";
export { ForwardRef as ReactComponent };